import React, { useContext } from 'react';
import { SearchContext } from './SearchContext';

const FooterBar = (props) => {
    const { footerLink, footerIcon, footerTitle, footerCount, footerProgress, footerButton, footerPlugin } = props;
    const { toggleSearch } = useContext(SearchContext);

    return (
        <div className="footer-bar">
            <div className="row align-items-start">
                <div className="col-12 d-flex align-items-center">
                    {footerLink ? (
                        <a href={footerLink} className="btn d-flex align-items-center px-1 pb-2">
                            <span className="material-symbols-outlined">{footerIcon}</span>
                            <h6 className="mb-0 ms-2">{footerTitle}</h6>
                        </a>) :
                        (<div className="btn-group dropup">
                            <div className="btn dropdown-toggle mr-2 d-flex align-items-center px-1 pb-2" style={{ position: 'relative' }} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label={footerTitle} title={footerTitle}>
                                <span className="material-symbols-outlined">{footerIcon}</span>
                                {footerCount && <h6 className="mb-0 ms-2">{footerCount}</h6>}
                                {footerProgress !== null && footerProgress !== undefined && (
                                    <div
                                        className="progress"
                                        role="progressbar"
                                        aria-valuemin={0}
                                        aria-valuemax={100}
                                        aria-valuenow={footerProgress}
                                        title={`Caricamento: ${footerProgress}%`}
                                        style={{ position: 'absolute', left: 4, right: 4, bottom: 2, height: 3 }}
                                    >
                                        <div className="progress-bar" style={{ width: `${footerProgress}%`, transition: 'width .3s' }} />
                                    </div>
                                )}
                            </div>
                            <div className="dropdown-menu footer-dropup-menu border-0 p-2 mb-2" style={{ minWidth: '200px' }}>
                                <div className="footer-dropup-title">{footerTitle}</div>
                                {footerButton}
                            </div>
                        </div>
                        )
                    }
                    <div style={{ marginLeft: 'auto', userSelect: 'none' }} className="d-flex align-items-center">
                        {footerPlugin}
                    </div>
                    <button
                        type="button"
                        className="btn d-flex align-items-center px-1 pb-2"
                        onClick={toggleSearch}
                        aria-label="Apri o chiudi la ricerca"
                    >
                        <span className="material-symbols-outlined">search</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
export default FooterBar;